<template>
  <div class="payment_method_wrapper">
    <div class="col-lg-12 col-md-12 col-sm-12 pt-35">
      <div v-for="payment in paymentOptionsList" :key="payment.id">
        <div
          class="col-lg-12 col-md-12 col-sm-12 box-border-wrapper mr-bt-10"
          :class="{ 'selected-box': payment_option == payment.id }"
          v-if="payment.display"
        >
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
              <base-radio
                :id="'payment-method_' + payment.id"
                name="payment-radio-group"
                v-model="payment_option"
                @change="emitValues()"
                :optionValue="payment.id"
                :label="payment.id"
              >
                <span class="default-label">
                  {{ payment.mode }}
                </span>

                <span v-if="payment.id === 1 && payment_option === 1"
                  >(Total Amount: ${{ totalPrice }})</span
                >
              </base-radio>
            </div>
          </div>
          <div class="pl-20" v-if="payment.id === 1 && payment_option === 1">
            <div id="secureFrameWrapper">
              <iframe
                id="secureFrame"
                class="secureFrame"
                style="border: none; backgroundcolor: #f4f4f4"
                height="550px"
                width="800px"
                :src="`${chaseurl}/hpf/1_1/?uID=${uID}`"
              >
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loadingStatus"></loader>
  </div>
</template>
<script>
import EventBus from '../../../utils/event-bus';
import { getChaseUID } from '../../../apis/chasePaymentAPIs';
import Loader from '../../UIComponents/Loader.vue';
import BaseRadio from '../../Common/BaseRadio.vue';

export default {
  props: ['paymentOptionsList', 'totalPrice'],
  data() {
    return {
      payment_option: '',
      uID: '',
      loadingStatus: false,
      chaseurl: ''
    };
  },
  components: { Loader, BaseRadio },
  methods: {
    emitValues() {
      this.$emit('paymentOpts', this.payment_option);
    },
    async chaseuID() {
      const formData = {
        amount: this.totalPrice,
        form_type_id: 0
      };
      const response = await getChaseUID(formData);
      this.uID = response.uid;
      this.$emit('uID', {
        id: response.id
      });
    }
  },
  watch: {
    async totalPrice() {
      if (this.payment_option === 1) {
        this.loadingStatus = true;
        await this.chaseuID();
        this.loadingStatus = false;
      }
    },
    async payment_option() {
      if (this.payment_option === 1 && this.totalPrice) {
        this.loadingStatus = true;
        await this.chaseuID();
        this.loadingStatus = false;
      }
    }
  },
  async mounted() {
    EventBus.$on('upgradeService', async () => {
      this.payment_option = '';
    });
  },
  created() {
    if (process.env.VUE_APP_CHASE_URL) {
      this.chaseurl = `${process.env.VUE_APP_CHASE_URL}`;
    } else {
      this.chaseurl = 'https://www.chasepaymentechhostedpay-var.com';
    }
  }
};
</script>
<style scoped>
.pt-35 {
  padding-top: 35px;
}
.payment_method_wrapper {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.7);
}
.cc-message {
  color: rgba(0, 0, 0, 0.7);
  font-weight: 400;
  font-size: 20px;
  padding-top: 12px;
}
.box-border-wrapper.selected-box {
  border: 3px solid #4c9e45;
}
::v-deep .selected-box .default-label {
  color: #0b3c61;
  font-weight: 500;
}
.mr-bt-10 {
  margin-bottom: 10px;
}
.box-border-wrapper {
  padding-top: 25px;
  padding-bottom: 20px;
  border: 1px solid #d3d6d9;
  border-radius: 10px;
}

.default-label {
  font-size: 20px;
  line-height: 17px;
}
</style>
